import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { formatNumber, Site } from '@debbie/common/dist/index.js';
import { RKIStates } from '@debbie/common/dist/customers/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import * as debtRegisterAPI from '@debbie/cortex/dist/api/debt-register.js';
import { Button, Badge } from '../index.js';
import THEME from '../../theme.js';
import ArrowDown from '../Icons/ArrowDown.js';
const RKIRegistration = (props) => {
    const { rkiReport, case: singleCase, setDebtorId, setRkiReferenceId } = props;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [concluding, setConcluding] = useState(false);
    const dropdown = (site === Site.Caseworker
        ? [
            [RKIStates.PUBLISHED, RKIStates.REPORTED].includes(rkiReport.state) && {
                value: 'Anmod Experian om sletning',
                onClick: () => {
                    props.toggleDeleteModal();
                    setDebtorId(rkiReport.referenceId);
                    setRkiReferenceId(rkiReport.rkiReferenceId);
                },
                theme: 'secondary',
            },
            [RKIStates.PUBLISHED, RKIStates.REPORTED].includes(rkiReport.state) &&
                rkiReport &&
                !(rkiReport.claim &&
                    rkiReport.claim.foundationCode &&
                    rkiReport.claim.foundationDate) && {
                value: 'Tilføj Fundament',
                onClick: () => {
                    props.toggleMoveToOpenModal();
                    setDebtorId(rkiReport.referenceId);
                    setRkiReferenceId(rkiReport.rkiReferenceId);
                },
                theme: 'secondary',
            },
            [RKIStates.PUBLISHED, RKIStates.REPORTED].includes(rkiReport.state) && {
                value: 'Markér Uerholdelig',
                onClick: async () => {
                    try {
                        setConcluding(true);
                        await debtRegisterAPI.rkiConclude(rkiReport.referenceId, singleCase.caseId, rkiReport.rkiReferenceId);
                        await c.cases.getById(singleCase.id);
                    }
                    catch (error) {
                        console.error(error);
                        const err = error?.message ? error.message : error;
                        alert(err);
                    }
                    setConcluding(false);
                },
                theme: 'secondary',
            },
            [RKIStates.PUBLISHED, RKIStates.REPORTED, RKIStates.ERROR].includes(rkiReport.state) && {
                value: 'Registrér status modtaget fra Experian',
                onClick: async () => {
                    props.setErrorModalOpen(true);
                    setRkiReferenceId(rkiReport.rkiReferenceId);
                },
                theme: 'secondary',
            },
            [RKIStates.PUBLISHED, RKIStates.REPORTED].includes(rkiReport.state) && {
                value: 'Tjek Status hos experian',
                onClick: async () => {
                    try {
                        props.setStatusModalOpen(true);
                        setDebtorId(rkiReport.referenceId);
                        setRkiReferenceId(rkiReport.rkiReferenceId);
                        const status = await debtRegisterAPI.rkiStatus(rkiReport.referenceId, singleCase.caseId, rkiReport.rkiReferenceId);
                        props.setRkiStatus(status);
                    }
                    catch (error) {
                        props.setStatusModalOpen(false);
                        console.error(error);
                        const err = error?.message ? JSON.parse(error.message) : error;
                        alert(err.description || err);
                    }
                },
                theme: 'secondary',
            },
        ]
        : []).filter((d) => !!d);
    return (React.createElement(React.Fragment, null,
        React.createElement(RKIRegistrationStyled, { active: [RKIStates.REPORTED, RKIStates.PUBLISHED].includes(rkiReport.state), "data-tooltip-content": rkiReport.error, "data-tooltip-id": `tooltip-default` },
            dropdown && !!dropdown.length && (React.createElement(Button, { loading: concluding, style: { float: 'right' }, theme: "light", 
                // @ts-ignore
                dropdown: dropdown },
                React.createElement(ArrowDown, null))),
            React.createElement(Badge, { theme: rkiReport.state === RKIStates.DELETED
                    ? THEME.DANGEROUS
                    : THEME.COLOR_SECONDARY, style: {
                    fontSize: '0.6em',
                    color: rkiReport.state === RKIStates.DELETED
                        ? 'inherit'
                        : THEME.COLOR_PRIMARY,
                } },
                "RKI ",
                rkiReport.state),
            rkiReport.reportedAt && (React.createElement("div", { className: "subheader", style: { fontSize: '0.6em', marginTop: '5px' } },
                moment(rkiReport.reportedAt).format(THEME.DATE_FORMAT_LONG),
                rkiReport.lastUpdateAt &&
                    rkiReport.reportedAt !== rkiReport.lastUpdateAt &&
                    `, opdateret ${moment(rkiReport.lastUpdateAt).format(THEME.DATE_FORMAT_LONG)}`)),
            rkiReport && rkiReport.claim && (React.createElement("div", { className: "price", style: {
                    fontSize: '0.85em',
                    marginTop: '5px',
                } },
                React.createElement("span", null, "DKK"),
                " ",
                formatNumber(rkiReport.claim.amount))),
            rkiReport && rkiReport.claim && rkiReport.claim.foundationCode && (React.createElement("div", { className: "foundation" },
                // @ts-ignore
                lang.RKI.foundationCode[rkiReport.claim.foundationCode] ||
                    rkiReport.claim.foundationCode,
                ' ',
                moment(rkiReport.claim.foundationDate).format(THEME.DATE_FORMAT))))));
};
export default RKIRegistration;
const RKIRegistrationStyled = styled.div `
  border-radius: 4px;
  background-color: ${(props) => (props.active ? THEME.WARNING : '#e6e6e6')};
  padding: 5px;
  margin-bottom: 10px;

  &:last-child {
    border-bottom: none;
  }

  & > span  {
    vertical-align: middle;
  }
  .price {
    vertical-align: middle;
    display: inline-block;
    opacity: 1;
    font-weight: bold;

    span {
      margin-right: 0.3em;
    }
  }

  .subheader {
    font-size: 0.8em;
    margin-bottom: 0.6em;
  }

  .foundation {
    font-size: 0.8em;
    margin-top: 0.6em;
  }
`;
//# sourceMappingURL=RKIRegistration.js.map